import React from 'react';
import PropTypes from 'prop-types';
import { values } from 'lodash';
import { ApolloContext } from '../../ApolloContextProvider';
import Alex from '../alex/Alex';
import AvatarPosition from './avatarConstants';

export default class Avatar extends React.Component {
    static get Position() {
        return AvatarPosition;
    }

    constructor(props) {
        super(props);
        this.hasBranch = this.hasBranch.bind(this);
        this.onAvatarClick = this.onAvatarClick.bind(this);
        this.avatarAnimation = this.avatarAnimation.bind(this);
        window.avatar = this;
    }

    componentWillUnmount() {
        this.props.stopSpeaking();
    }

    onAvatarClick() {
        if (!this.props.isScreenBlocked && this.props.owlyCanSpeak) {
            this.props.onClick(this.props.instructions, this.props.postAudioCallback);
        }
    }

    hasBranch() {
        return (
            this.props.position !== Avatar.Position.CENTER ||
            this.props.position !== Avatar.Position.HIDDEN
        );
    }

    avatarAnimation() {
        return this.props.isSpeaking ? 'speaking' : 'default';
    }

    renderAvatar() {
        return (
            <div
                className={
                    !this.props.animateAlex ? 'alex-container alyx' : 'alex-animate-container alyx'
                }
            >
                <Alex
                    avatarConfig={{
                        avatarPosition: this.props.position,
                        animateAlex: this.props.animateAlex,
                    }}
                />
            </div>
        );
    }

    render() {
        const { position, isScreenBlocked, isScreenGreyedOut } = this.props;
        return (
            <div
                className={`assessment-window avatar-window avatar-transition hide-alyx-btn
                 ${position}  ${isScreenBlocked ? 'block-screen' : ''}  ${
                    isScreenGreyedOut ? 'disabled-measure' : ''
                }`}
            >
                {this.renderAvatar()}
            </div>
        );
    }
}

Avatar.contextType = ApolloContext;

Avatar.propTypes = {
    onClick: PropTypes.func.isRequired,
    postAudioCallback: PropTypes.func,
    instructions: PropTypes.array,
    position: PropTypes.oneOf(values(Avatar.Position)),
    isSpeaking: PropTypes.bool.isRequired,
    stopSpeaking: PropTypes.func.isRequired,
    isScreenBlocked: PropTypes.bool,
    isScreenGreyedOut: PropTypes.bool,
    owlyCanSpeak: PropTypes.bool,
    animateAlex: PropTypes.bool,
    ongoingMeasureName: PropTypes.shape({
        name: PropTypes.string,
    }),
};

Avatar.defaultProps = {
    instructions: [],
    postAudioCallback: undefined,
    position: Avatar.Position.MIDDLE_LEFT,
    isScreenBlocked: false,
    isScreenGreyedOut: false,
    owlyCanSpeak: true,
    animateAlex: false,
    ongoingMeasureName: {
        name: '',
    },
};
